<template>
	<div class="pages" v-loading="listLoading">
		<div v-for='(item,index) in templateData.TemplateContent.Controls' :key='index'>
			<Digit v-if='item.Property.Control=="Number"' :data-val='item'></Digit>
			<Contact v-if='item.Property.Control=="Condition"' :data-val="item"></Contact>
			<Dates v-if='item.Property.Control=="Date"' :data-val="item"></Dates>
			<Version v-if='item.Property.Control=="Text"' @child-event='getTextVal' :data-val="item"></Version>
			<Money v-if='item.Property.Control=="Money"' :data-val="item"></Money>
			<Tips v-if='item.Property.Control=="Tips"' :data-val="item"></Tips>
			<File v-if='item.Property.Control=="File"' :data-val="item"></File>
			<Table v-if='item.Property.Control=="Table"' @child-event='tableOperation' :data-val='item' :template-data='templateData'></Table>
			<Selector v-if='item.Property.Control=="Selector"' @child-event='getSelectorVal' :data-val='item'></Selector>
			<Textarea v-if='item.Property.Control=="Textarea"' :data-val='item'></Textarea>
			<Choose v-if='item.Property.Control=="Contact"' @child-event='clickChoose' :data-val='item'></Choose>
		</div>
		<Button class="submit-process" v-on:click='submit' v-bind:loading="formLoading" size="large" type="primary"> 核价确认</Button>
		<Button class="submit-process" v-on:click='refuse' v-bind:loading="formLoading" size="large" type="primary"> 驳回
		</Button>
	</div>
</template>

<script>
	/**
	 * Version 为Text文本组件
	 */
	import Digit from '../components/Number.vue'
	import Contact from '../components/Contact.vue';
	import Dates from '../components/Date.vue';
	import Version from '../components/Text.vue';
	import Money from '../components/Money.vue';
	import Tips from '../components/Tips.vue';
	import File from '../components/File.vue';
	import Table from '../components/Table.vue';
	import Selector from '../components/Selector.vue';
	import Textarea from '../components/Textarea.vue';
	import Choose from '../components/Choose.vue';
	import wx from 'weixin-js-sdk'
	import stringUtils from "../assets/js/stringUtil.js";
	import {
		initWxConfig
	} from '../api/jssdk.js';
	import {
		getTemplateInfo,
		submitProcess,
		sendMessage,
		getFlowTemplate,
		getMediaId,
		getApproverDetailInfo,
		GetPendingProcessById
	} from '@/api/approval'
	import {
		getRelation
	} from '@/api/employee'
	import {
		getDepartmentRelationByName
	} from '@/api/department'
	var isSubmit = false;

	var template = {
		TemplateContent: {
			Controls: []
		}
	};
	const sendMessagetTemplate = {
		title: null,
		url: null,
		toUser: [],
		desc: null,
		template: null,
	};
	export default {
		components: {
			Contact,
			Dates,
			Version,
			Money,
			Tips,
			File,
			Table,
			Digit,
			Selector,
			Textarea,
			Choose
		},
		data() {
			return {
				templateData: template,
				relationList: null,
				logInfo: null,
				templateId: "",
				spNo: null,
				formLoading: false,
				listLoading: false,
				applyTemplateData: null,
				flowId: null,
				sendMessageData: Object.assign({}, sendMessagetTemplate)
			}
		},
		created() {
			initWxConfig(this);
			this.logInfo = this.getLoginUserInfo();
			this.templateId = this.$route.query.templateId;
			this.flowId = this.$route.query.flowId;
			this.spNo = this.$route.query.spNo;
			this.getTemplate();
			stringUtils.setAddIsShow(true);
		},
		methods: { //方法

			clickChoose(dataVal, name) {
				window.wx.invoke("selectEnterpriseContact", {
					"fromDepartmentId": 0, // 必填，表示打开的通讯录从指定的部门开始展示，-1表示自己所在部门开始, 0表示从最上层开始
					"mode": "single", // 必填，选择模式，single表示单选，multi表示多选
					"type": ["department"], // 必填，选择限制类型，指定department、user中的一个或者多个
					"selectedDepartmentIds": [], // 非必填，已选部门ID列表。用于多次选人时可重入，single模式下请勿填入多个id
					"selectedUserIds": [] // 非必填，已选用户ID列表。用于多次选人时可重入，single模式下请勿填入多个id
				}, function(res) {
					if (res.err_msg == "selectEnterpriseContact:ok") {
						if (typeof res.result == 'string') {
							res.result = JSON.parse(res.result) //由于目前各个终端尚未完全兼容，需要开发者额外判断result类型以保证在各个终端的兼容性
						}
						var depart = res.result.departmentList[0]; // 已选的部门列表
						dataVal.Values = [];
						dataVal.Values.push([depart.id, depart.name]);
						dataVal.Value = depart.name;
					}
				})
			},

			getTemplate: async function() {
				await GetPendingProcessById(this.flowId).then(response =>{
					if(response.Body==null){
						this.Message({
							message: '该流程已经处理完成',
							type: 'success',
							duration: 3 * 1000
						});
						setTimeout(() => {
							this.$router.push("/Pricing");
						}, 1000)
						return;
					}
				})
				this.listLoading = true;
				var title = this.logInfo.fullName;
				var jobLevel = this.logInfo.JobLevel;
				await getTemplateInfo(this.templateId).then(async response => {
					var controls = response.Body;
					await this.getFlowTemplateInfo();
					await this.getEmployeeRelation();
					await controls.TemplateContent.Controls.forEach((item, index) => {
						var departs = this.logInfo.fullName.split("/");

						if (item.Property.Title[0].Text == "请选择审批流程") {
							item.Disable = true;
							item.IsShow = false;
							item.Value = this.applyTemplateData.TemplateContent.Controls.filter(t => {
								return t.Property.Title[0].Text == "请选择审批流程"
							})[0].Value
						}
						if (item.Property.Title[0].Text == "合计") {
							item.Disable = true;
							item.Value = this.applyTemplateData.TemplateContent.Controls.filter(t => {
								return t.Property.Title[0].Text == "合计"
							})[0].Value
						}
						if (item.Property.Title[0].Text == "申请部门") {
							item.Disable = true;
							item.Value = this.applyTemplateData.TemplateContent.Controls.filter(t => {
								return t.Property.Title[0].Text == "申请部门"
							})[0].Value
							item.Values = this.applyTemplateData.TemplateContent.Controls.filter(t => {
								return t.Property.Title[0].Text == "申请部门"
							})[0].Values
						}
						if (item.Property.Title[0].Text == "部门经理") {
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "流程编号") {
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "行政主任") {
							item.Values = this.applyTemplateData.TemplateContent.Controls.filter(t => {
								return t.Property.Title[0].Text == "行政主任"
							})[0].Values
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "总经理/副总经理") {
							item.Values = this.applyTemplateData.TemplateContent.Controls.filter(t => {
								return t.Property.Title[0].Text == "总经理/副总经理"
							})[0].Values
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "行政经理") {
							item.Values = this.applyTemplateData.TemplateContent.Controls.filter(t => {
								return t.Property.Title[0].Text == "行政经理"
							})[0].Values
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "小战区区董") {
							item.Values = this.applyTemplateData.TemplateContent.Controls.filter(t => {
								return t.Property.Title[0].Text == "小战区区董"
							})[0].Values
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "大战区区董") {
							item.Values = this.applyTemplateData.TemplateContent.Controls.filter(t => {
								return t.Property.Title[0].Text == "大战区区董"
							})[0].Values
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "非营业逐级审批") {
							item.Values = this.applyTemplateData.TemplateContent.Controls.filter(t => {
								return t.Property.Title[0].Text == "非营业逐级审批"
							})[0].Values
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "经理/总监") {
							item.Values = this.applyTemplateData.TemplateContent.Controls.filter(t => {
								return t.Property.Title[0].Text == "经理/总监"
							})[0].Values
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "总经理") {
							item.Values = this.applyTemplateData.TemplateContent.Controls.filter(t => {
								return t.Property.Title[0].Text == "总经理"
							})[0].Values
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "部门总经理/总监") {
							item.Values = this.applyTemplateData.TemplateContent.Controls.filter(t => {
								return t.Property.Title[0].Text == "部门总经理/总监"
							})[0].Values
							item.IsShow = false;
						}
						if(item.Property.Title[0].Text == "关联申请单"){
							item.Value = this.spNo;
						}
						
						if (item.Property.Title[0].Text == "维修") {
							item.Disable = true;
							var control = this.applyTemplateData.TemplateContent.Controls.filter(t => {
								return t.Property.Title[0].Text == "维修"
							})[0];
							if (control != null) {
								item.Value = control.Value;
							} else {
								item.IsShow = false;
							}
						}
						
						if (item.Property.Title[0].Text == "申请原因") {
							item.Disable = true;
							item.Value = this.applyTemplateData.TemplateContent.Controls.filter(t => {
								return t.Property.Title[0].Text == "申请原因"
							})[0].Value;
						}

						if (item.Property.Title[0].Text == "合计") {
							item.Disable = true;
							item.Value = this.applyTemplateData.TemplateContent.Controls.filter(t => {
								return t.Property.Title[0].Text == "合计"
							})[0].Value;
						}
						if (item.Property.Title[0].Text == "类别") {
							item.Disable = true;
							item.Value = this.applyTemplateData.TemplateContent.Controls.filter(t => {
								return t.Property.Title[0].Text == "类别"
							})[0].Value;
						}
						if (item.Property.Title[0].Text == "申请人员") {
							item.Disable = true;
							if (this.applyTemplateData != null) {
								var empName = this.applyTemplateData.TemplateContent.Controls.filter(t => {
									return t.Property.Title[0].Text == "人员"
								})[0].Value;
								var empNo = this.applyTemplateData.TemplateContent.Controls.filter(t => {
									return t.Property.Title[0].Text == "工号"
								})[0].Value;
								item.Values = [
									[empNo, empName]
								];
								item.Value = empName;
							}

						}
						if (item.Property.Title[0].Text == "申请人员工号") {
							item.Disable = true;
							item.Value = this.applyTemplateData.TemplateContent.Controls.filter(t => {
								return t.Property.Title[0].Text == "工号"
							})[0].Value;
						}
						if (item.Property.Title[0].Text == "核价人员") {
							item.Disable = true;
							item.Value = this.logInfo.EmpName
						}
						if (item.Property.Title[0].Text == "核价人工号") {
							item.Disable = true;
							item.Value = this.logInfo.EmpNo
						}


					});
					var controlsLength = controls.TemplateContent.Controls.length;
					console.log(this.applyTemplateData.TemplateContent);
					// for (var j = 0; j < controlsLength; j++) {
					// 	var controlsData = controls.TemplateContent.Controls[j];
					// 	var departs = this.logInfo.fullName.split("/");
					// 	if (this.applyTemplateData != null) {
							
					// 		var data = this.applyTemplateData.TemplateContent.Controls.filter(t => {
					// 			return t.Property.Title[0].Text == controlsData.Property.Title[0].Text
					// 		});
					// 		if (controlsData.Property.Title[0].Text == "申请项目内容") {
					// 			// controlsData.addIsShow = false;
					// 			var i = 1;
					// 			this.applyTemplateData.TemplateContent.Controls.forEach(async (applyData) => {
					// 				if (applyData.Property.Title[0].Text.indexOf("申请项目内容") > -1) {
					// 					if (applyData.Property.Title[0].Text != "申请项目内容") {
					// 						var AddTable = JSON.stringify(controlsData);
					// 						AddTable = JSON.parse(AddTable);
					// 						AddTable.Property.Id = "Table-1600687377709";
					// 						AddTable.Property.Title[0].Text = AddTable.Property.Title[0].Text + i;
					// 						AddTable.addIsShow = false;
					// 						// AddTable.Config.Table.Children.forEach(forDisable => {
					// 						// 	forDisable.Disable = true;
					// 						// });
					// 						controls.TemplateContent.Controls.splice(j + i, 0, AddTable);
					// 						i++;
					// 					}
					// 				}
					// 			});
					// 			// controlsData.Config.Table.Children.forEach(childItem => {
					// 			// 	childItem.Disable = true;
					// 			// })
					// 			break;
					// 		}
					// 	}
					// }
					this.templateData = this.assignControl(controls, this.logInfo);
					this.templateData = await this.assignControlBySpNo(controls, this.spNo, this.flowId,true);
					this.listLoading = false;
					// await controls.TemplateContent.Controls.forEach((item) => {
					// 	if (item.Property.Title[0].Text == "申请人员部门") {
					// 		item.Disable = true;
					// 		item.IsShow = false;
					// 		var select = this.applyTemplateData.TemplateContent.Controls.filter(t => {
					// 			return t.Property.Title[0].Text == "申请人员部门"
					// 		})[0];
					// 		var text = select.Config.Selector.Options.filter(t => {
					// 			return t.Key == select.Value
					// 		})[0].Value[0].Text;
					// 		item.Value = item.Config.Selector.Options.filter(e => {
					// 			return e.Value[0].Text == text
					// 		})[0].Key;
					// 		console.log(item)
					// 	}
					// 	// if (item.Property.Title[0].Text == "核价上传附件") {
					// 	// 	this.$set(item, 'fileNames', [])
					// 	// 	if (item.Values != null) {
					// 	// 		item.Values.forEach(data => {
					// 	// 			getMediaId(data[0]).then(res => {
					// 	// 				data[0] = res.MediaId;
					// 	// 				item.fileNames.push({
					// 	// 					"key": res.fileName,
					// 	// 					"val": res.MediaId
					// 	// 				});
					// 	// 			});
					// 	// 		});
					// 	// 	}
					// 	// }
					// 	// if (item.Property.Title[0].Text == "申请上传附件") {
					// 	// 	this.$set(item, 'fileNames', [])
					// 	// 	if (item.Values != null) {
					// 	// 		item.Values.forEach(data => {
					// 	// 			getMediaId(data[0]).then(res => {
					// 	// 				data[0] = res.MediaId;
					// 	// 				item.fileNames.push({
					// 	// 					"key": res.fileName,
					// 	// 					"val": res.MediaId
					// 	// 				});
					// 	// 			});
					// 	// 		});
					// 	// 	}
					// 	// }
					// });
				});
			},
			getEmployeeRelation: async function() {
				await getRelation(this.logInfo.EmpNo).then(response => {
					this.relationList = response.Body[0].Nodes;
				});
			},
			getFlowTemplateInfo: async function() {
				if (this.flowId == null || this.flowId == undefined || this.flowId.length <= 0) {
					return;
				}
				await getFlowTemplate(this.flowId).then(response => {
					this.applyTemplateData = response.Body;
				});
			},
			getTextVal() {},
			getSelectorVal(val, name) {
				if (name == "类别") {
					var controls = this.templateData.TemplateContent.Controls;
					var controlInfo = controls.filter(item => item.Property.Title[0].Text == name)[0];
					var option = controlInfo.Config.Selector.Options
						.filter(item => {
							return item.Value[0].Text == "维修" && val.indexOf(item.Key) > -1;
						})[0];
					var control = controls.filter(item => item.Property.Title[0].Text == "维修")[0];
					if (option != null) {
						control.IsShow = true;
						control.Property.Require = 1;
					} else {
						control.IsShow = false;
						control.Property.Require = 0;
					}
				}
			},
			tableOperation(val, type, datas) {
				if (type == 'compute') {
					return;
				}
				this.tableoperation(val, type, datas, this);
			},
			refuse() {
				this.sendMessageData.template = this.templateData;
				this.sendMessageData.title = "工程费用申请";
				var toUser = this.templateData.TemplateContent.Controls.filter(t => {
								return t.Property.Title[0].Text == "申请人员"
							})[0].Values[0][0];
				this.sendMessageData.toUser = [toUser];
				this.sendMessageData.desc = "驳回人员：" + this.logInfo.EmpName;
				this.sendMessageData.url = document.location.hostname +
					"/ProjectCostApplication?templateId=ZLyg8Ad2f3V6zTZLiqjghGoQTKxoeohw8u13kK&flowId=" + this.flowId;
				//提交
				sendMessage(this.templateId, this.logInfo.EmpNo, this.spNo, this.sendMessageData, 2,"",this.flowId).then(response => {
					this.Message({
						message: '驳回成功',
						type: 'success',
						duration: 3 * 1000
					});
					setTimeout(() => {
						this.$router.push("/index");
					}, 3000)
				}).finally(() => {});
			},
			submit() {
				//数据校验
				if (!this.submitValidate(this.templateData.TemplateContent.Controls)) {
					return;
				}
				var SummaryList = [];
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				var control0=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "申请人员"})[0]
				var control1=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "申请部门"})[0]
				info.SummaryInfo.push({"Text":"申请人信息："+control0.Value + " "+control1.Value  ,"Lang":"zh_CN"});
				SummaryList.push(info);
				
				// var control3=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "类别"})[0]
				// var info={SummaryInfo:[]}
				// info.SummaryInfo=[];
				// var NameOfData = "";
				// for (var i = 0; i < control3.Config.Selector.Options.length; i++) {
				// 	var data = control3.Config.Selector.Options[i];
				// 	if(data.Key ==control3.Value){
				// 		NameOfData = data.Value[0].Text;
				// 	}
				// }
				// info.SummaryInfo.push({"Text":"类别："+ NameOfData ,"Lang":"zh_CN"});
				// SummaryList.push(info);
				
				
				var control5=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "申请表别称"})[0]
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				info.SummaryInfo.push({"Text":"申请表别称："+control5.Value  ,"Lang":"zh_CN"});
				SummaryList.push(info);
				
				var control4=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "核价确认（元）"})[0]
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				info.SummaryInfo.push({"Text":"核价确认（元）："+control4.Value,"Lang":"zh_CN"});
				SummaryList.push(info);
				
				this.templateData.SummaryList=SummaryList
				if (isSubmit) {
					this.Message({
						message: '已提交',
						type: 'warning',
						duration: 1000
					});
					return;
				}

				isSubmit = true;
				this.listLoading = true;
				var toUser = this.templateData.TemplateContent.Controls.filter(t => {
								return t.Property.Title[0].Text == "申请人员"
							})[0].Values[0][0];
				//提交
				console.log(JSON.stringify(this.templateData.TemplateContent.Controls));
				submitProcess(this.templateId, toUser, this.spNo, this.templateData, this.flowId).then(response => {
					this.Message({
						message: '申请成功',
						type: 'success',
						duration: 3 * 1000
					});
					setTimeout(() => {
						this.$router.push("/index");
					}, 3000)
				}).finally(() => {
					isSubmit = false;
					this.listLoading = false;
				});
			}
		}

	}
</script>

<style scoped lang="less">
	.pages {
		padding-bottom: 14px;
	}
</style>
